import { useEffect, useRef } from 'react';

import {
  initializeFullstory,
  fsEvent,
  initializeAndStopFullstory,
} from 'js/fullstory';
import { currentUser } from 'js/utils/user';

/**
 * Hook to initialize FullStory with sampling and fire an initial event.
 *
 * @param eventName - Event name to fire on initialization (e.g. 'MyFeaturePageLoad')
 * @param sampleRate - Sampling rate for FullStory recording (0-1), defaults to 0
 */
export default function useFullstory(
  eventName: string,
  sampleRate: number = 0,
): { trackEvent: (name: string, details?: Record<string, unknown>) => void } {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (window.$rails_env === 'development') {
      return;
    }

    if (initializedRef.current) {
      return;
    }

    if (Math.random() >= sampleRate) {
      return;
    }

    initializedRef.current = true;

    initializeAndStopFullstory();
    initializeFullstory(currentUser ?? undefined, true);

    fsEvent(eventName);
  }, [eventName, sampleRate]);

  return {
    trackEvent: (name: string, details?: Record<string, unknown>) => {
      if (initializedRef.current) {
        fsEvent(name, details);
      }
    },
  };
}
